module.exports = __webpack_public_path__ + "img/icon-notice-active.fa8ca06a.svg";